<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  data() {
    return {
      intervalChart: "",
      dataLabels: [],
      workedHoursDataValues: [],
      overtimeDataValues: [],
      sundayDataValues: [],
      nightDataValues: [],
      absencesDataValues: [],
      maxNumber: null
    };
  },
  props: {
    label: {
      type: String,
    },
    chartData: {
      type: Object,
    },
  },
  methods: {
    makeChart() {
        let maxOne, maxTwo, maxThree, maxFour
        let allMaxed = []
        this.chartData.arrayData.forEach((element) => {
          if (Math.sign(element.entradaSalida.AllWorkedHoursDay) === -1) element.entradaSalida.AllWorkedHoursDay = 0; else element.entradaSalida.AllWorkedHoursDay;
          if (Math.sign(element.entradaSalida.AllWorkedOvertimeDay) === -1) element.entradaSalida.AllWorkedOvertimeDay = 0; else element.entradaSalida.AllWorkedOvertimeDay;
          if (Math.sign(element.entradaSalida.AllSundayHoursDay) === -1) element.entradaSalida.AllSundayHoursDay = 0; else element.entradaSalida.AllSundayHoursDay;
          if (Math.sign(element.entradaSalida.AllNightHoursDay) === -1) element.entradaSalida.AllNightHoursDay = 0; else element.entradaSalida.AllNightHoursDay;
          this.dataLabels.push(element.entradaSalida.fecha.substring(8, 10))
          this.workedHoursDataValues.push(element.entradaSalida.AllWorkedHoursDay)
          this.overtimeDataValues.push(element.entradaSalida.AllWorkedOvertimeDay)
          this.sundayDataValues.push(element.entradaSalida.AllSundayHoursDay)
          this.nightDataValues.push(element.entradaSalida.AllNightHoursDay)
          //this.absencesDataValues.push(element.entradaSalida.AllAbsencesDay)
        })

        maxOne = Math.max.apply(null, this.workedHoursDataValues)
        maxTwo = Math.max.apply(null, this.overtimeDataValues)
        maxThree = Math.max.apply(null, this.sundayDataValues)
        maxFour = Math.max.apply(null, this.nightDataValues)

        if (maxOne) allMaxed.push(maxOne);
        if (maxTwo) allMaxed.push(maxTwo);
        if (maxThree) allMaxed.push(maxThree);
        if (maxFour) allMaxed.push(maxFour);
        
        this.maxNumber = Math.max.apply(null, allMaxed) + (40 / 100 * Math.max.apply(null, allMaxed))

        this.renderChart(
        {
          labels: this.dataLabels,
          datasets: [
            {
              label: "Laboradas",
              data: this.workedHoursDataValues,
              backgroundColor: '#60a5fa',
            },
            {
              label: "Extras",
              data: this.overtimeDataValues,
              backgroundColor: '#f87171',
            },
            {
              label: "Dominicales",
              data: this.sundayDataValues,
              backgroundColor: '#34d399',
            },
            {
              label: "Nocturnas",
              data: this.nightDataValues,
              backgroundColor: '#818cf8',
            },
            /* {
                label: "Ausencias",
                data: this.absencesDataValues,
                backgroundColor: '#FDD835',
            }, */
          ],
        },
        {
          maintainAspectRatio: false,
          animations: {
            duration: 0, // general animation time
          },
          hover: {
            animationDuration: 0, // duration of animations when hovering an item
          },
          responsiveAnimationDuration: 0,
          responsive: true,
          elements: {
            /* line: {
              tension: 0.4,
            }, */
          },
          legend: {
            labels: {
              fontColor: "#ddd",
            },
          },
          scales: {
            xAxes: [
              {
                gridLines: { 
                  color: '#434a5a',
                },
                ticks: {
                  fontColor: "#ddd",
                },
              },
            ],
            yAxes: [
              {
                gridLines: { 
                  color: '#434a5a',
                  tickMarkLength: 0,
                  drawBorder: false,
                  zeroLineColor: "transparent",
                },
                ticks: {
                  fontColor:  "#ddd",
                  suggestedMax: Math.round(this.maxNumber),
                  padding: 5,
                }
              },
            ],
          },
          title: {
            display: false,
          },
          tooltips: {
            enable: true,
            mode: "single",
            /* callbacks: {
              title: function (tooltipItems) {
                return "Hora: " + tooltipItems[0].xLabel;
              },
            }, */
          },
        }
      );
    },

    callDataChartEvery() {
      this.intervalChart = window.setInterval(
        function () {
          this.makeChart();
          this.dataLabels = []
          this.workedHoursDataValues = []
          this.overtimeDataValues = []
          this.sundayDataValues = []
          this.nightDataValues = []
          this.absencesDataValues = []
        }.bind(this),
        3000000
      );
    },
  },
  mounted() {
    //this.callDataChartEvery();
    this.makeChart();
  },
  beforeDestroy() {
    clearInterval(this.intervalChart);
  },
};
</script>
